module.exports = file => () => import('@/containers/' + file + '.vue');
